import { DataTypes as SeqDataTypes, Utils } from "sequelize";
import { createHash } from "crypto";

class PASSWORD extends SeqDataTypes.STRING {
  _stringify(value) {
    return createHash("sha512").update(value).digest("base64");
  }
}

PASSWORD.prototype.key = PASSWORD.key = "PASSWORD";

SeqDataTypes.PASSWORD = Utils.classToInvokable(PASSWORD);

export const DataTypes = SeqDataTypes;
